/** returns list of accounts
@return { Array }
*/
export const getAccountsList = state => {
    return state.accountsList
}

/** returns financialPlan data
@return { Array }
*/
export const getFinancialPlan = state => {
    return state.financialPlan
}

/** returns financialPlan list
@return { Array }
*/
export const getFinancialPlanList = state => {
    return state.financialPlanList
}

/** returns movements hasMore value
@return { Boolean }
*/
export const getFinancialPlanHasMore = state => state.financialPlanHasMore

/** returns movements list
@return { Array }
*/
export const getMovementsList = state => {
    return state.movements
}

/** returns Last Movement releaseDatePosition & orderNumberPosition info
@return { Object }
*/
export const getLastMovementInfo = state => state.lastMovementInfo

/** returns movements hasMore value
@return { Boolean }
*/
export const getMovementsHasMore = state => state.movementsHasMore

/** returns list patrimony acccount list
@return { Object }
*/
export const getPatrimonyAccountList = state => state.patrimonyAccountList
